<ng-container *ngIf="loadingData">
  <div class="d-flex justify-content-center mt-5">
    <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50"></mat-progress-spinner>
  </div>
</ng-container>
<salon-finder-outlet-form [formModel]="outletForm" *ngIf="!loadingData"></salon-finder-outlet-form>